import repository from "../Repository";

export default {
  /**
   * 参照API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async list(screenId, payload) {
    return await repository.post(`tmp_qrresidents_info`, payload, {
      headers: {
        s: screenId
      }
    });
  },

  /**
   * 更新API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async update(screenId, payload) {
    return await repository.patch(`tmp_qrresident_ope`, payload, {
      headers: {
        s: screenId
      }
    });
  },

  /**
   * 削除API（更新APIと処理は同じ）
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async delete(screenId, payload) {
    return await this.update(screenId, payload);
  }
};
